import { makeAutoObservable } from 'mobx';
import {api} from 'shared/core';
import {endpoints} from 'main/tools';

class PayrollNotEnabledState {
  interestedInPayrollModalOpen = false;

  constructor() {
    makeAutoObservable(this);
  }

  openInterestedInPayrollModal() {
    this.interestedInPayrollModalOpen = true;
  }

  closeInterestedInPayrollModal() {
    this.interestedInPayrollModalOpen = false;
  }

  async submit() {
    await api.post(endpoints.PAYROLL.INTERESTED, {source: 'payroll_page'});
    this.openInterestedInPayrollModal();
  }
}

export default PayrollNotEnabledState;
